import React from 'react';
import PropTypes from 'prop-types';
import styles from '../badgeBase.module.scss';
import BadgeShieldCheck from '../BadgeShieldCheck';

const TwineRecommends = ({
  user,
  className = '',
  style,
  title = 'Twine Recommends',
  iconOnly = false,
  ...rest
}) => {
  if (!user || !user.twine_recommends) {
    return null;
  }

  const classNames = [
    styles.badge,
    styles.twineRecommends,
    iconOnly ? styles.iconOnly : null,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <span className={classNames} style={style} title={title} {...rest}>
      <BadgeShieldCheck variant="twineRecommends" outline={!iconOnly} />
      {iconOnly ? null : <span className={styles.label}>Twine Recommends</span>}
    </span>
  );
};

TwineRecommends.propTypes = {
  user: PropTypes.shape({
    twine_recommends: PropTypes.bool,
  }),
  className: PropTypes.string,
  style: PropTypes.object,
  title: PropTypes.string,
  iconOnly: PropTypes.bool,
};

export default TwineRecommends;
